import React from 'react';

export default function AiInteractionModals({
  showAiModalForProjectId, // ID of project for AI prompt modal, or null
  aiRequestText,
  onAiRequestTextChange, // Function to update text in parent state
  onCloseAiModal,
  onSubmitAiRequest, // Function to trigger AI request
  showLogsModalConfig, // { projectId, interactionId } or null
  logsLoading,
  currentLogs,
  onCloseLogsModal
}) {

  // --- AI Prompt Modal ---
  const renderAiPromptModal = () => {
    if (showAiModalForProjectId === null) return null;

    return (
      <div className="popup-overlay" onClick={onCloseAiModal}>
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <div className="popup-header">
            <h3>Generuj modyfikacje AI</h3>
            <button onClick={onCloseAiModal} className="popup-close-btn">&times;</button>
          </div>
          <div className="popup-body">
            <p>Wpisz treść polecenia dla AI, aby zmodyfikować projekt:</p>
            <textarea
              rows={5}
              value={aiRequestText}
              onChange={(e) => onAiRequestTextChange(e.target.value)} // Use callback
              placeholder="np. Zmień czcionkę imion na bardziej elegancką, dodaj tekst 'Dziękujemy' na dole strony..."
              style={{ width: '100%', minHeight: '80px', marginBottom: '10px' }}
            />
          </div>
          <div className="popup-footer">
            <button
              onClick={() => onSubmitAiRequest(showAiModalForProjectId)} // Pass projectId
              className="popup-btn popup-btn-confirm"
              disabled={!aiRequestText.trim()}
            >
              Wyślij do AI
            </button>
            <button onClick={onCloseAiModal} className="popup-btn popup-btn-cancel">
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  };

  // --- AI Logs Modal ---
  const renderAiLogsModal = () => {
    if (showLogsModalConfig === null) return null;

    return (
      <div className="popup-overlay" onClick={onCloseLogsModal}>
        <div className="popup-content popup-logs" onClick={(e) => e.stopPropagation()}>
          <div className="popup-header">
            <h3>Logi interakcji AI</h3>
            <button onClick={onCloseLogsModal} className="popup-close-btn">&times;</button>
          </div>
          <div className="popup-body">
            {logsLoading ? (
              <p>Ładowanie logów...</p>
            ) : (
              <pre className="ai-logs-content">
                {currentLogs || "Brak logów do wyświetlenia."}
              </pre>
            )}
          </div>
          <div className="popup-footer">
            <button onClick={onCloseLogsModal} className="popup-btn popup-btn-confirm">
              Zamknij
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderAiPromptModal()}
      {renderAiLogsModal()}
    </>
  );
}
